// =============================================================================
// consoleAdmin.js — qui ouvre la console d'administration (source unique)
// =============================================================================
// Audit du 28/09/2026 : l'écran d'administration avait TROIS portes.
//   1. La session Aramis (passkey, mot de passe + TOTP ou SSO), dont le rôle
//      est émis par le SERVEUR au login (withRoleCanonique, functions/auth.js).
//   2. Une valeur `eniovote_admin` dans localStorage, acceptée dès qu'elle
//      était bien formée : n'importe qui pouvait l'écrire depuis la console du
//      navigateur et se faire passer pour administrateur, voire pour
//      super-administrateur (`isSuperAdmin:true`).
//   3. Une « console » mot de passe + TOTP super-admin dont l'empreinte (non
//      salée) et la graine TOTP vivaient dans config/settings, document lisible
//      et modifiable par tout visiteur, et vérifiées DANS LE NAVIGATEUR ; tant
//      que l'empreinte manquait, l'écran offrait un accès libre.
// Les portes 2 et 3 sont supprimées. Ne reste que la session : c'est elle, et
// elle seule, qui décide. Pierre (seul super-administrateur) ne s'est jamais
// servi de la porte 3 (aucune trace depuis le 30/06) : il se connecte par
// passkey, et sa session porte le rôle « superadmin ».
// =============================================================================

/** Le rôle de session ouvre-t-il la console d'administration ? */
export const estSessionAdmin = (session) =>
  !!session && (session.role === "admin" || session.role === "superadmin");

/** Identité affichée par la console, dérivée de la SEULE session Aramis.
 *  null quand la session n'est pas administratrice : l'écran dit alors
 *  « Accès réservé », il ne propose plus aucun formulaire. */
export function adminInfoDepuisSession(session) {
  if (!estSessionAdmin(session) || !session.id) return null;
  return {
    prenom: session.prenom || "",
    nom: session.nom || "",
    id: session.id,
    isSuperAdmin: session.role === "superadmin",
    fromAramis: true,
  };
}

/** Écran à montrer quand la console n'est pas ouverte :
 *  - « rouvrir » : la console s'est refermée pour inactivité, mais la session
 *    Aramis est toujours administratrice. Un bouton la rouvre (sans lui, le
 *    super-administrateur restait devant un écran sans issue, l'ancien
 *    formulaire ne connaissant que la collection `admins`, vide) ;
 *  - « reserve » : tout autre cas. */
export const ecranConsoleFermee = (session) => (estSessionAdmin(session) ? "rouvrir" : "reserve");
